module.exports = __webpack_public_path__ + "img/date.7c06bb0c.svg";